import en from "./en";
import hu from "./hu";

export const dictionaries = {
  en,
  hu
};

export const languageOptions = [
  { id: "hu", text: "Magyar", flag: "HU" },
  { id: "en", text: "English", flag: "GB" }
];
